import type { Sample } from 'mp4box';
import { Stores } from './constants';
import { deleteAllData, deleteBulkData, deleteData, getBulkDataByKeys, getDataByKey, initDB, setBulkData } from './idb';
import type { EncodedFrameData } from './types';
export const storeEncodedFrames = async (mediaFileReference: string, startIndex: number, samples: Sample[], timescale: number) => {
  try {
    await initDB();
    const frameDataArray: EncodedFrameData[] = samples.map((sample, i) => ({
      id: `${mediaFileReference}:${startIndex + i}`,
      sample,
      timescale
    }));
    await setBulkData(Stores.VideoFrames, frameDataArray);
    return true;
  } catch (error) {
    console.error('[VideoFrameStore] Error storing encoded frames:', error);
    return false;
  }
};
export const getEncodedFrameRange = async (mediaFileReference: string, startFrame: number, endFrame?: number): Promise<EncodedFrameData | EncodedFrameData[] | null> => {
  try {
    await initDB();
    if (endFrame === undefined) {
      const frameData = await getDataByKey<EncodedFrameData>(Stores.VideoFrames, `${mediaFileReference}:${startFrame}`);
      return frameData;
    }
    const keys: string[] = [];
    for (let i = startFrame; i <= endFrame; i++) {
      keys.push(`${mediaFileReference}:${i}`);
    }
    const frames = await getBulkDataByKeys<EncodedFrameData>(Stores.VideoFrames, keys);
    return frames;
  } catch (error) {
    console.error('Error getting encoded frame:', error);
    return null;
  }
};
export const deleteEncodedFrameRange = async (mediaFileReference: string, startFrame: number, endFrame?: number) => {
  try {
    await initDB();
    if (endFrame === undefined) {
      await deleteData(Stores.VideoFrames, `${mediaFileReference}:${startFrame}`);
      return true;
    }
    const keys: string[] = [];
    for (let i = startFrame; i <= endFrame; i++) {
      keys.push(`${mediaFileReference}:${i}`);
    }
    await deleteBulkData(Stores.VideoFrames, keys);
    return true;
  } catch (error) {
    console.error('Error deleting encoded frame:', error);
    return false;
  }
};
export const cleanupAllVideoFrames = async () => {
  try {
    await initDB();
    await deleteAllData(Stores.VideoFrames);
    return true;
  } catch (error) {
    console.error('Error cleaning up all video frames:', error);
    return false;
  }
};